import {AUTH_EVENTS} from '@/app/auth/events/AuthEvents';
import {PROJECT_TAGS} from '@/constants';
import {trackEventLogic} from '@/hooks/TrackingManager/trackingManager';
import {TrackingEvent} from '@/services/segment/models/TrackingManagerEventModel';
import {getTrackingService} from '@/services/tracking/getTrackingService';
import {wafProtectionService} from '@/services/wafProtection/WafProtectionService';

/**
 * `reAuth` runs inside the RTK Query `baseQuery` pipeline, not inside a React
 * component/hook, so it can't use `useTrackingManager()` like every other
 * `trackers.ts` in the codebase — the tracking service is resolved lazily,
 * on each call, instead of once at module load time.
 */
const getTrackEventService = () => getTrackingService().trackEvent;

export const trackWafEvent = (
  url: string,
  event: any,
  trackEvent: TrackingEvent,
) => {
  wafProtectionService.incrementWafCount();

  trackEventLogic({
    eventName: trackEvent,
    eventData: {
      project_tag: PROJECT_TAGS.APP_ISSUES,
      WAF: {
        count: wafProtectionService.getCountError(),
        response: {
          status: event?.status,
          headers: event?.headers,
        },
        request: {
          body: event?.body,
          url,
          headers: event?.headers,
          method: event?.method,
        },
      },
    },
    trackEventService: getTrackEventService(),
  });
};

export const trackUserUnauthorized = () => {
  trackEventLogic({
    eventName: AUTH_EVENTS.USER_UNAUTHORIZED,
    eventData: {
      project_tag: PROJECT_TAGS.APP_ISSUES,
    },
    trackEventService: getTrackEventService(),
  });
};
